<template>
  <base-page-layout ref="base-page" class="product-details" title="Detalhes do produto">
    <v-layout>
      <v-flex xs3>
        <busca-component class="overlay" search-type="produto" />
      </v-flex>
    </v-layout>

    <v-layout class="mt-4">
      <v-flex>
        <v-card class="mt-2">
          <mf-loading loader-type="dynamic" :dynamic-amount="1" :booleanLoader="loading">
            <v-card-title>
              <v-layout>
                <span class="pa-1 title">{{ produtoNomeCodigo }}</span>
              </v-layout>
            </v-card-title>
            <v-card-text v-if="produtoErpCategoriesLabel">
              <span class="pa-1 subtitle">
                {{ produtoErpCategoriesLabel }}
              </span>
              <copy-button tooltip="Copiar categorias para área de transferência" size="xs" @click="copyErpCategories" />
            </v-card-text>
          </mf-loading>
        </v-card>
      </v-flex>
    </v-layout>

    <v-divider class="my-4" />

    <v-container fluid class="pa-0">
      <v-row class="pa-4">
        <magic-price-point class="mpp" :produto-selecionado="produtoSelecionado" />
        <v-spacer />
        <filters-menu :filters="['lojas', 'data']" default-date="ultimosTrintaDias" />
      </v-row>
    </v-container>

    <v-container class="pa-0" fluid grid-list-lg>
      <v-layout>
        <v-flex v-for="(card, index) in cards" :key="index" xs6>
          <cbm-card
            :number-text="card.value"
            :title="card.text"
            :tooltip="card.helpText"
            :is-currency="card.isCurrency"
            :loader="card.loader"
            use-loader
            unset-percentage-colors
            simple-card
          />
        </v-flex>
      </v-layout>
    </v-container>

    <v-container class="pa-0" fluid grid-list-lg>
      <v-layout wrap row>
        <v-flex xs4>
          <horas-mais-frequentes-card :items="tabelaHorasMaioresCompras" module="produtos" />
        </v-flex>
        <v-flex xs4>
          <dias-mais-frequentes-card :items="tabelaDiasSemanaMaioresCompras" module="produtos" />
        </v-flex>
        <v-flex xs4>
          <dia-mes-mais-frequente-card :items="tabelaDiasMaioresCompras" module="produtos" />
        </v-flex>
      </v-layout>
    </v-container>

    <hora-chart :data="chartHorasMaioresCompras" />
    <dia-semana-chart :data="chartDiasSemanaMaioresCompras" />
    <dia-mes-chart :data="chartDiasMaioresCompras" />
  </base-page-layout>
</template>

<script>
import range from 'lodash/range'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import BasePageLayout from '@/components/BasePageLayout.vue'
import CopyButton from '@/components/CopyButton.vue'
import HorasMaisFrequentesCard from '@/components/busca-detalhes/HorasMaisFrequentesCard.vue'
import DiasMaisFrequentesCard from '@/components/busca-detalhes/DiasMaisFrequentesCard.vue'
import DiaMesMaisFrequenteCard from '@/components/busca-detalhes/DiaMesMaisFrequenteCard.vue'
import HoraChart from '@/components/busca-detalhes/HoraChart.vue'
import DiaSemanaChart from '@/components/busca-detalhes/DiaSemanaChart.vue'
import DiaMesChart from '@/components/busca-detalhes/DiaMesChart.vue'
import CbmCard from '@/components/CbmCard.vue'
import BuscaComponent from '@/components/busca-detalhes/BuscaComponent.vue'
import MagicPricePoint from '@/modules/produtos/magic-price-point/views/pages/MagicPricePoint.vue'
import { assertArray, localeString } from '@/config/helpers.js'
import { mapGetters, mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import gql from 'graphql-tag'
export const QUERY_PRODUCT = gql`
  query Product($sku: String) {
    findProduct(filter: { legacySku: $sku }) {
      legacySku
      erpCategoriesArr
      name
      erpCategories {
        erpId
        name
      }
    }
  }
`

export default {
  components: {
    BasePageLayout,
    HorasMaisFrequentesCard,
    DiasMaisFrequentesCard,
    DiaMesMaisFrequenteCard,
    HoraChart,
    DiaSemanaChart,
    DiaMesChart,
    CbmCard,
    BuscaComponent,
    FiltersMenu: () => import('@/components/FiltersMenu.vue'),
    MagicPricePoint,
    CopyButton,
  },
  data: () => ({
    loading: false,
    produtoSelecionado: null,
  }),
  computed: {
    ...mapState({
      stateHora: (state) => state.produtos.horasMaioresCompras,
      stateMes: (state) => state.produtos.diasMaioresCompras,
      stateSemana: (state) => state.produtos.diasSemanaMaioresCompras,
      stateFilters: (state) => state.filters,
    }),
    ...mapGetters(['produtosPrecoMedio', 'produtosQuantidadeCesta']),
    arrayHora() {
      let array = []
      for (let count of range(24)) {
        let stateObject = find(this.stateHora, { NUM_HORA: count })
        if (stateObject) array.push(stateObject)
        else array.push({ NUM_HORA: count, NUM_TOTAL_CUPONS: 0 })
      }
      return array
    },
    arraySemana() {
      let array = []
      for (let count of range(7)) {
        let stateObject = find(this.stateSemana, { NUM_DIA_SEMANA: count })
        if (stateObject) array.push(stateObject)
        else array.push({ NUM_DIA_SEMANA: count, NUM_TOTAL_CUPONS: 0 })
      }
      return array
    },
    arrayMes() {
      let array = []
      for (let count of range(1, 32)) {
        let stateObject = find(this.stateMes, { NUM_DIA: count })
        if (stateObject) array.push(stateObject)
        else array.push({ NUM_DIA: count, NUM_TOTAL_CUPONS: 0 })
      }
      return array
    },
    tabelaHorasMaioresCompras() {
      return orderBy(this.arrayHora, 'NUM_TOTAL_CUPONS', 'desc')
    },
    tabelaDiasMaioresCompras() {
      return orderBy(this.arrayMes, 'NUM_TOTAL_CUPONS', 'desc')
    },
    tabelaDiasSemanaMaioresCompras() {
      return orderBy(this.arraySemana, 'NUM_TOTAL_CUPONS', 'desc')
    },
    chartHorasMaioresCompras() {
      return assertArray(this.arrayHora)
    },
    chartDiasMaioresCompras() {
      return assertArray(this.arrayMes)
    },
    chartDiasSemanaMaioresCompras() {
      return assertArray(this.arraySemana)
    },
    produtoNomeCodigo() {
      if (this.produtoSelecionado) return `${this.produtoSelecionado.sku} - ${this.produtoSelecionado.name}`
      return ''
    },
    produtoErpCategories() {
      if (!this.$getAllowedModules()['products_tree']) return []
      return this.produtoSelecionado.erpCategories || []
    },
    produtoErpCategoriesLabel() {
      return this.produtoErpCategories.map((category) => category.name).join(' > ')
    },
    produtoErpCategoriesCopyContent() {
      return this.produtoErpCategories.map((category) => `[${category.erpId}] ${category.name}`).join(' > ')
    },
    cards() {
      return [
        {
          value: localeString(this.produtosPrecoMedio || 0, 2),
          text: 'Preço médio',
          isCurrency: true,
          loader: ['primeiro-registro', 'preco-medio'],
        },
        {
          value: localeString(this.produtosQuantidadeCesta || 0, 1),
          text: 'Média de itens na cesta',
          loader: ['primeiro-registro', 'quantidade-cesta'],
        },
      ]
    },
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.buscaProdutoById()
    }
  },
  mounted() {
    this.searchFromComponent()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getProdutoDetalhes)
      this.$bus.$on('search', this.searchFromComponent)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
    this.$bus.$off('search')
  },
  methods: {
    ...mapWaitingActions({
      precoMedio: 'preco-medio',
      quantidadeCesta: 'quantidade-cesta',
      horasMaioresCompras: 'horas-compras',
      diasMaioresCompras: 'dias-compras',
      diasSemanaMaioresCompras: 'semana-compras',
    }),
    copyErpCategories() {
      navigator.clipboard.writeText(this.produtoErpCategoriesCopyContent)
    },
    getProdutoDetalhes() {
      if (!this.produtoSelecionado || !this.stateFilters.data) return
      this.$nextTick(() => {
        let filter = {
          produto: this.produtoSelecionado.sku,
          unidades: this.stateFilters.unitsConfiguration,
          date: this.stateFilters.data,
        }
        this.precoMedio(filter)
        this.quantidadeCesta(filter)
        this.horasMaioresCompras(filter)
        this.diasMaioresCompras(filter)
        this.diasSemanaMaioresCompras(filter)
      })
    },
    back() {
      this.$router.push({ path: '/produtos/busca-produto' }).catch(() => {})
      this.produtoSelecionado = null
    },
    buscaProdutoById() {
      this.loading = true
      return new Promise((resolve) => {
        this.$apollo
          .query({
            query: QUERY_PRODUCT,
            variables: {
              sku: this.$route.params.id,
            },
            fetchPolicy: 'no-cache',
          })
          .then(({ data: { findProduct } }) => {
            this.produtoSelecionado = {
              sku: findProduct.legacySku,
              name: findProduct.name,
              erpCategories: findProduct.erpCategories,
            }
            resolve()
            this.loading = false
          })
          .catch((error) => {
            console.log(error)
            this.$snackbar({ message: 'Erro ao buscar produto', snackbarColor: 'error' })
            this.loading = false
          })
      })
    },
    searchFromComponent() {
      this.buscaProdutoById().then(() => {
        this.getProdutoDetalhes()
      })
    },
  },
}
</script>

<style lang="scss">
.product-details {
  .product-title {
    font-size: 24px;
  }
  .search-link {
    color: $marca-0-l40;
    cursor: pointer;
  }
  .overlay {
    width: inherit;
    z-index: 1;
    position: absolute;
    top: 40px;
    right: 24px;
  }
  .mpp {
    z-index: 1;
    position: absolute;
    top: 248px;
    left: 20px;
  }
}
</style>
